import { get, map, size } from 'lodash';
import React from 'react';
import ModalCreateComentario from './ModalCreateComentario';
import ItemAlternativa from './ItemAlternativa';
import LabelView from './LabelView';
import Video from './Video';
import { API_HOST, TIPOS_ITENS } from '../consts';
import FlashCard from './FlashCard';
import Lacuna from './Lacuna';
import TextareaAutosize from 'react-textarea-autosize';
import { Radio } from '@material-ui/core';
import axios from 'axios';

class ItemConteudo extends React.Component {
  state = {
    activeTab: 'conteudo',
    matrizes_referencia: [],
    rubricas: [],
    fetchingMatrizesReferencia: true,
    studentView: false,
    answerView: 1,
    answerValue: '',
    showAnswer: false,
    resDiscursivaMultAlternative: [],
    selectedSpan: null,
    showCommentModal: false
  };
  static defaultProps = {
    labels: {}
  };

  componentDidMount() {
    if (TIPOS_ITENS.DISCURSIVO_COM_RUBICAS) {
      this.fetchRubricas();
    }
  }

  escapeRegExp(string) {
    return String(string).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  getHighlightedHtml(htmlString, comentarios, origin) {
    if (!htmlString || !comentarios || comentarios.length === 0) return htmlString;

    // SSR fallback: regex
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      let result = htmlString;
      comentarios && comentarios.filter(d => d.resolvido === false && d.origem_comentario === origin).forEach((c) => {
        const text = c && c.texto_selecionado ? c.texto_selecionado.trim() : null;
        if (!text) return;
        if (result.includes(`data-comentario-id=\"${c.id}\"`)) return;
        try {
          const re = new RegExp(this.escapeRegExp(text), 'g');
          const wrap = `<span class=\"comentario-marcado\" data-comentario-id=\"${c.id}\" title=\"Comentário #${c.id}\">${text}<span class=\"comentario-id\">#${c.id}</span></span>`;
          result = result.replace(re, wrap);
        } catch (e) {
          console.error('Erro ao marcar comentário', c.id, e);
        }
      });
      return result;
    }

    // DOM approach: suporta seleções com tags (ex: negrito)
    let container = document.createElement('div');
    container.innerHTML = htmlString;
    comentarios && comentarios.filter(d => d.resolvido === false && d.origem_comentario === origin).forEach((c) => {
      const text = c && c.texto_selecionado ? c.texto_selecionado.trim() : null;
      if (!text) return;
      if (container.querySelector(`[data-comentario-id="${c.id}"]`)) return;
      try {
        // Junta todos os nós de texto
        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
        let nodes = [], acc = '';
        let n;
        while ((n = walker.nextNode())) {
          nodes.push({ node: n, start: acc.length, end: acc.length + n.nodeValue.length });
          acc += n.nodeValue;
        }
        const idx = acc.indexOf(text);
        if (idx === -1) return;
        // Descobre o nó e offset inicial e final
        let startNode, startOffset, endNode, endOffset;
        for (let i = 0; i < nodes.length; i++) {
          if (idx >= nodes[i].start && idx < nodes[i].end) {
            startNode = nodes[i].node;
            startOffset = idx - nodes[i].start;
          }
          if ((idx + text.length - 1) >= nodes[i].start && (idx + text.length - 1) < nodes[i].end) {
            endNode = nodes[i].node;
            endOffset = idx + text.length - nodes[i].start;
          }
        }
        if (startNode && endNode) {
          const range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          const span = document.createElement('span');
          span.className = 'comentario-marcado';
          span.setAttribute('data-comentario-id', c.id);
          span.title = `Comentário #${c.id}`;
          // Conteúdo do range
          const frag = range.extractContents();
          span.appendChild(frag);
          // Adiciona o id visual
          const idSpan = document.createElement('span');
          idSpan.className = 'comentario-id';
          idSpan.textContent = `#${c.id}`;
          span.appendChild(idSpan);
          range.insertNode(span);
        }
      } catch (e) {
        // fallback para regex se der erro
        try {
          const re = new RegExp(this.escapeRegExp(text), 'g');
          const wrap = `<span class=\"comentario-marcado\" data-comentario-id=\"${c.id}\" title=\"Comentário #${c.id}\">${text}<span class=\"comentario-id\">#${c.id}</span></span>`;
          container.innerHTML = container.innerHTML.replace(re, wrap);
        } catch (e2) {
          console.error('Erro ao marcar comentário', c.id, e, e2);
        }
      }
    });
    return container.innerHTML;
  }

  renderHighlightStyle() {
    return (
      <style>{`.comentario-marcado{background-color:#fff3b0;padding:0 2px;border-radius:2px;border-bottom:1px dashed #e6c44d;} .comentario-id{color:#6c6c6c;font-size:11px;margin-left:6px;font-weight:600;vertical-align:super;}`}</style>
    );
  }
  handleBtnStudentView() {
    const { studentView } = this.state;
    this.setState({ studentView: !studentView });
  }

  handleBtnCheckAnswerView() {
    this.setState({ answerView: 0 });
  }

  fetchRubricas() {
    const { item } = this.props;
    const itemId = get(item, 'id');
    return axios
      .get(`${API_HOST}/itens/discursivo_rubrica/${itemId}/get_rubrica`)
      .then((response) => {
        this.setState({ rubricas: response.data });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleBtnAnswerView() {
    const { resDiscursivaMultAlternative, answerValue, answerView } =
      this.state;
    const { item } = this.props;
    const array = [];
    if (resDiscursivaMultAlternative.length === item.numero_respostas - 1) {
      array.push(...resDiscursivaMultAlternative, answerValue);
      this.setState({ resDiscursivaMultAlternative: array });
      this.setState({ answerView: 0 });
    } else {
      if (resDiscursivaMultAlternative.length === 0) {
        array.push(answerValue);
        this.setState({ resDiscursivaMultAlternative: array });
      } else {
        array.push(...resDiscursivaMultAlternative, answerValue);
        this.setState({ resDiscursivaMultAlternative: array });
      }
    }
  }
  handleInputAnswerValue(value) {
    this.setState({ answerValue: value });
  }
  handleBtnCorrectAnswer() {
    const { showAnswer } = this.state;
    this.setState({ showAnswer: !showAnswer });
  }

  checkAnswerDiscursive(correctAnswer, answer, arrayCorrectAnswer) {
    const res = arrayCorrectAnswer
      ? arrayCorrectAnswer.includes(answer)
      : correctAnswer == answer;
    const color = res ? '#008000' : '#800000';
    return color;
  }

  checkAnswerMultipleDiscursive(item, questions) {
    let res = { correct: false, index: 0 };
    let i = 0;

    while (res.correct == false && i < questions.length) {
      res =
        questions[i] == item
          ? { correct: true, index: i }
          : questions[i].includes(item)
            ? { correct: true, index: i }
            : { correct: false, index: -1 };
      i++;
    }

    return res;
  }


  handleModal = (value) => {
    this.setState({ showCommentModal: value });
  }

  handleTextAlternativeSelection = (alternativaId, origin) => {
    const selection = window.getSelection();
    const selectedText = selection.toString();

    if (!selectedText || selectedText.trim().length === 0) return;

    const alternativas = get(this.props, 'item.alternativas', []);
    const alternativa = alternativas.find(a => String(a.id) === String(alternativaId));
    let fullHtml = alternativa ? (alternativa.descricao || alternativa.texto || '-') : '-';
    if (typeof fullHtml !== 'string') {
      fullHtml = '';
    }
    const fullText = fullHtml.replace(/<[^>]*>/g, '');
    const tokens = fullText.split(/\s+/).filter(Boolean);

    const sel = selectedText.trim();
    const startChar = fullText.indexOf(sel);
    if (startChar === -1) return;

    // Converte posição de caracteres para índice de tokens
    let charPos = 0;
    let tokenStart = 0;
    for (let i = 0; i < tokens.length; i++) {
      if (charPos >= startChar) {
        tokenStart = i;
        break;
      }
      charPos += tokens[i].length + 1; // inclui espaço
      if (i === tokens.length - 1) tokenStart = tokens.length - 1;
    }

    const selectedTokens = sel.split(/\s+/).filter(Boolean);
    const tokenEnd = Math.min(tokenStart + selectedTokens.length, tokens.length);

    const originForId = `descricao_alternativa_${alternativaId}`;

    this.setState((prev) => ({
      selectedSpan: { text: sel, start: tokenStart, end: tokenEnd, origin: originForId },
      showCommentModal: true,
    }));
  }

  handleTextSelection = (command_text) => {
    const selection = window.getSelection();
    const selectedText = selection.toString();

    if (!selectedText || selectedText.trim().length === 0) return;

    const fullHtml = get(this.props, `item.${command_text}`);
    const fullText = fullHtml.replace(/<[^>]*>/g, '');
    const tokens = fullText.split(/\s+/).filter(Boolean);

    const sel = selectedText.trim();
    const startChar = fullText.indexOf(sel);
    if (startChar === -1) return;

    // Converte posição de caracteres para índice de tokens
    let charPos = 0;
    let tokenStart = 0;
    for (let i = 0; i < tokens.length; i++) {
      if (charPos >= startChar) {
        tokenStart = i;
        break;
      }
      charPos += tokens[i].length + 1; // inclui espaço
      if (i === tokens.length - 1) tokenStart = tokens.length - 1;
    }

    const selectedTokens = sel.split(/\s+/).filter(Boolean);
    const tokenEnd = Math.min(tokenStart + selectedTokens.length, tokens.length);

    this.setState((prev) => ({
      selectedSpan: { text: sel, start: tokenStart, end: tokenEnd, origin: command_text },
      showCommentModal: true,
    }));
  }

  renderConteudo() {
    const { showCommentModal } = this.state;
    const { item, labels, avaliacaoItem, enableHighlight } = this.props;
    const comentarios = get(this.props, 'avaliacaoItem.comentarios');

    return (
      <div id={`item-${get(item, 'id')}`}>
        {this.renderHighlightStyle()}
        <div className="row">
          {get(item, 'tipo.id') > 6 ? (
            <LabelView
              title={get(item, 'tipo.descricao')}
              text={
                (() => {
                  const original = get(item, 'situacao_problema', '-');
                  return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'situacao_problema') : original;
                })()
              }
              html
              onMouseUp={() => enableHighlight ? this.handleTextSelection('situacao_problema') : undefined}
              name="situacao_problema"
            />
          ) : (
            <>
              <LabelView
                title={labels.situacao_problema || 'Situação Problema'}
                text={(() => {
                  const original = get(item, 'situacao_problema', '-');
                  return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'situacao_problema') : original;
                })()}
                html
                onMouseUp={() => enableHighlight ? this.handleTextSelection('situacao_problema') : undefined}
                name="situacao_problema"
              />
              <ModalCreateComentario
                isModalOpen={showCommentModal}
                avaliacaoItem={avaliacaoItem}
                api={this.props.api}
                handleModal={this.handleModal}
                selectedSpan={this.state.selectedSpan}
              />
            </>
          )}
          {get(item, 'tipo.id') < 7 ? (
            <LabelView
              title={labels.comando_resposta || 'Comando Resposta'}
              text={
                (() => {
                  const original = get(item, 'comando_resposta', '-');
                  return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'comando_resposta') : original;
                })()
              }
              html
              onMouseUp={() => enableHighlight ? this.handleTextSelection('comando_resposta') : undefined}
              name="comando_resposta"
            />
          ) : (
            <></>
          )}
          {size(get(item, 'arquivos')) > 0 && (
            <LabelView
              title="Vídeo"
              text={map(get(item, 'arquivos'), (arquivo) => (
                <Video
                  key={arquivo.src}
                  src={arquivo.src}
                  type={arquivo.content_type}
                />
              ))}
              name="arquivos"
            />
          )}
          {this.renderAlternativas()}
        </div>
      </div>
    );
  }

  renderAlternativas() {
    const alternativas = get(this.props, 'item.alternativas', []);
    const { item, labels, avaliacaoItem, showCommentModal, enableHighlight } = this.props;

    if (alternativas.length === 0 && get(item, 'tipo.id') < 7) {
      return (
        <div className="col-md-12">
          <p className="azul">
            <i className="fas fa-exclamation-circle" /> Este objeto de
            aprendizagem não possui alternativas.
          </p>
        </div>
      );
    }
    if (
      alternativas.length > 0 &&
      get(item, 'tipo.id') !== TIPOS_ITENS.MULTIPLA_ESCOLHA_MULTIPLA &&
      get(item, 'tipo.id') !== TIPOS_ITENS.MULTIPLA_ESCOLHA_UNICA
    ) {
      return <></>;
    }

    const gabarito = alternativas.find((x) => x.gabarito);
    const comentarios = get(this.props, 'avaliacaoItem.comentarios');
    return (
      <React.Fragment>
        <div className="col-md-12">
          <ul className="alternatives style-list">
            {alternativas.map((alternativa) => (
              <ItemAlternativa
                text={
                  (() => {
                    const original = get(alternativa, 'descricao', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, `descricao_alternativa_${alternativa.id}`) : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextAlternativeSelection(alternativa.id, 'descricao') : undefined}
                showJustificativa
                key={alternativa.id}
                {...alternativa}
              />
            ))}
            <ModalCreateComentario
              isModalOpen={showCommentModal}
              avaliacaoItem={avaliacaoItem}
              api={this.props.api}
              handleModal={this.handleModal}
              selectedSpan={this.state.selectedSpan}
            />
          </ul>
        </div>
        <div className="row">
          <div className="col-md-12">
            {get(item, 'tipo.id') < 7 ? (
              <LabelView
                html
                title="Justificativa do gabarito"
                text={get(gabarito, 'justificativa', '-')}
                name="alternativa"
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderEscalaLinearMultipla() {
    const escalaLinearMultipla = get(this.props, 'item.grade_linear', []);

    if (escalaLinearMultipla === null) {
      return (
        <div className="col-md-12">
          <p className="azul">
            <i className="fas fa-exclamation-circle" /> Este objeto de
            aprendizagem não possui escala linear múltipla.
          </p>
        </div>
      );
    }

    if (escalaLinearMultipla !== null) {
      const escalaReplace = JSON.parse(escalaLinearMultipla.replace(/'/g, '"'));

      if (escalaLinearMultipla.length === 0) {
        return (
          <div className="col-md-12">
            <p className="azul">
              <i className="fas fa-exclamation-circle" /> Este objeto de
              aprendizagem não possui escala linear múltipla.
            </p>
          </div>
        );
      }

      return (
        <React.Fragment>
          <div
            className="col-md-12"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <table className="table-escala">
              <thead>
                <tr>
                  <th></th>
                  {escalaReplace.column &&
                    escalaReplace.column.map((column) => (
                      <th
                        style={{ marginLeft: '1.5rem' }}
                        key={column.position}
                        align="center"
                      >
                        {column.value}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {escalaReplace.row &&
                  escalaReplace.row.map((row) => (
                    <tr key={row.position}>
                      <td align="left">{row.value}</td>
                      {escalaReplace.column &&
                        escalaReplace.column.map((column) => (
                          <td key={column.position} align="center">
                            <Radio
                              disabled
                              className="radio__button__fake"
                              color="primary"
                              name={`${row.value} ${column.value}`}
                              value={`${row.position} ${column.position}}`}
                            />
                          </td>
                        ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      );
    }
  }

  renderimagem() {
    const { item } = this.props;
    const { studentView } = this.state;

    return (
      <div id={`item-${get(item, 'id')}`}>
        <button
          onClick={() => {
            this.handleBtnStudentView();
          }}
          style={{
            marginTop: '1rem',
            marginBottom: '3rem',
            outline: 'none',
            boxShadow: 'none',
            borderRadius: '70px',
            backgroundColor: 'gray',
            border: 'none',
            color: 'white',
            padding: '5px 23px',
            fontSize: '15px'
          }}
        >
          {!studentView ? 'Visualizar como estudante' : 'Visualizar resposta'}
        </button>

        {!studentView ? (
          <div>
            <div className="row">
              <LabelView
                html
                name="situacao_problema"
                text={get(item, 'situacao_problema', '-')}
              />
            </div>
            <div className="row">
              <LabelView
                html
                col="col-md-3"
                title="Mínimo de palavras"
                text={get(item, 'min_palavras', '-')}
                name="min_palavras"
              />
              <LabelView
                html
                col="col-md-3"
                title="Máximo de palavras"
                text={get(item, 'max_palavras', '-')}
                name="max_palavras"
              />
              <LabelView
                html
                col="col-md-3"
                title="Mínimo de linhas"
                text={get(item, 'min_linhas', '-')}
                name="min_linhas"
              />
              <LabelView
                html
                col="col-md-3"
                title="Máximo de linhas"
                text={get(item, 'max_linhas', '-')}
                name="max_linhas"
              />
            </div>
          </div>
        ) : (
          <div>
            <div
              className="col-md-12"
              style={{
                backgroundColor: 'white',
                padding: '20px',
                color: 'black',
                boxShadow: 'rgb(0 0 0 / 10%) 0px 2px 2px',
                height: 'fit-content'
              }}
            >
              <LabelView
                html
                name="situacao_problema"
                text={get(item, 'situacao_problema', '-')}
              />
            </div>

            <span
              style={{
                margin: '5px',
                fontStyle: 'italic',
                fontSize: '0.7rem'
              }}
            >
              Caso tenha alguma dificuldade para visualizar a questão,{' '}
              <div
                style={{
                  display: 'inline'
                }}
              >
                <button
                  marginBottom="0rem"
                  marginTop="10px"
                  style={{
                    color: 'rgb(106, 53, 221)',
                    marginTop: '1rem',
                    marginBottom: '0rem',
                    padding: 0,
                    textDecoration: 'underline',
                    outline: 'none',
                    boxShadow: 'none',
                    background: 'none',
                    border: 'none'
                  }}
                >
                  clique aqui
                </button>{' '}
              </div>
              para recarregá-la.
            </span>

            <TextareaAutosize
              className="col-md-12"
              placeholder="Escreva sua resposta..."
              minRows={5}
              style={{
                width: '100%',
                maxWidth: '100%',
                fontSize: '16px',
                padding: '5px',
                lineHeight: 1.5,
                backgroundColor: 'white',
                border: '2px solid #f5f5f5',
                borderRadius: '5px'
              }}
            />
          </div>
        )}
      </div>
    );
  }

  renderDiscursivo() {
    const { item, avaliacaoItem, enableHighlight } = this.props;
    const comentarios = get(this.props, 'avaliacaoItem.comentarios');
    const {
      studentView,
      answerValue,
      answerView,
      showAnswer,
      resDiscursivaMultAlternative,
      showCommentModal
    } = this.state;
    const tipo = get(item, 'tipo.id');
    const responses = item.expectativa_resposta;
    const correctAnswer =
      responses &&
      responses
        .replace(/<p>/g, '')
        .replace('</p>', '')
        .replace(/\[/g, '')
        .replace(/\]/g, '');

    const arrayCorrectAnswer =
      correctAnswer && correctAnswer.includes('|')
        ? correctAnswer.split('|')
        : false;

    const questions =
      item && item.expectativa_resposta
        ? item.expectativa_resposta
          .slice(responses.indexOf('[') + 1, responses.lastIndexOf(']'))
          .replace(/\[/g, '')
          .replace(/\]/g, '')
          .split(';')
        : [''];

    questions.forEach((question, i) => {
      questions[i] = question.includes('|') ? question.split('|') : question;
    });

    var answerLength = answerValue.length;

    return (
      <div id={`item-${get(item, 'id')}`}>
        <button
          onClick={() => {
            this.handleBtnStudentView();
          }}
          style={{
            backgroundColor: '#47b9bb',
            color: 'white',
            marginTop: '1rem',
            marginBottom: '3rem',
            padding: '4px 6px',
            outline: 'none',
            boxShadow: 'none',
            border: 'none',
            borderRadius: '4px'
          }}
        >
          {!studentView ? 'Visualizar como estudante' : 'Visualizar resposta'}
        </button>

        {!studentView ? (
          <div>
            <div className="row">
              <LabelView
                html
                name="situacao_problema"
                title="Enunciado"
                text={
                  (() => {
                    const original = get(item, 'situacao_problema', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'situacao_problema') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('situacao_problema') : undefined}
              />
              <LabelView
                html
                name="expectativa_resposta"
                title="Comando resposta"
                text={
                  (() => {
                    const original = get(item, 'comando_resposta', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'comando_resposta') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('comando_resposta') : undefined}
              />
              <LabelView
                html
                name="expectativa_resposta"
                title="Expectativa de resposta"
                text={
                  (() => {
                    const original = get(item, 'expectativa_resposta', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'expectativa_resposta') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('expectativa_resposta') : undefined}
              />
              <LabelView
                html
                name="orientacao_correcao"
                title="Orientação de correção"
                text={
                  (() => {
                    const original = get(item, 'orientacao_correcao', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'orientacao_correcao') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('orientacao_correcao') : undefined}
              />
            </div>
            <div className="row">
              <LabelView
                html
                col="col-md-3"
                title="Mínimo de palavras"
                text={
                  (() => {
                    const original = get(item, 'min_palavras', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'min_palavras') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('min_palavras') : undefined}
                name="min_palavras"
              />
              <LabelView
                html
                col="col-md-3"
                title="Máximo de palavras"
                text={
                  (() => {
                    const original = get(item, 'max_palavras', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'max_palavras') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('max_palavras') : undefined}
                name="max_palavras"
              />
              <LabelView
                html
                col="col-md-3"
                title="Mínimo de linhas"
                text={
                  (() => {
                    const original = get(item, 'min_linhas', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'min_linhas') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('min_linhas') : undefined}
                name="min_linhas"
              />
              <LabelView
                html
                col="col-md-3"
                title="Máximo de linhas"
                text={
                  (() => {
                    const original = get(item, 'max_linhas', '-');
                    return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios, 'max_linhas') : original;
                  })()
                }
                onMouseUp={() => enableHighlight ? this.handleTextSelection('max_linhas') : undefined}
                name="max_linhas"
              />
            </div>
          </div>
        ) : (
          <div>
            {tipo != TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA ? (
              <>
                <div
                  className="col-md-12"
                  style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    color: 'black',
                    boxShadow: 'rgb(0 0 0 / 10%) 0px 2px 2px',
                    height: 'fit-content'
                  }}
                >
                  <LabelView
                    html
                    name="situacao_problema"
                    text={get(item, 'situacao_problema', '-')}
                  />
                  <LabelView
                    html
                    name="expectativa_resposta"
                    text={get(item, 'comando_resposta', '-')}
                  />
                </div>

                {answerView == 1 ? (
                  <>
                    <span
                      style={{
                        margin: '5px',
                        fontStyle: 'italic',
                        fontSize: '0.7rem'
                      }}
                    >
                      Caso tenha alguma dificuldade para visualizar a questão,{' '}
                      <div
                        style={{
                          display: 'inline'
                        }}
                      >
                        <button
                          marginBottom="0rem"
                          marginTop="10px"
                          style={{
                            color: 'rgb(106, 53, 221)',
                            marginTop: '1rem',
                            marginBottom: '0rem',
                            padding: 0,
                            textDecoration: 'underline',
                            outline: 'none',
                            boxShadow: 'none',
                            background: 'none',
                            border: 'none'
                          }}
                        >
                          clique aqui
                        </button>{' '}
                      </div>
                      para recarregá-la.
                    </span>
                    <TextareaAutosize
                      className="col-md-12"
                      placeholder="Escreva sua resposta..."
                      minRows={5}
                      style={{
                        width: '100%',
                        maxWidth: '100%',
                        fontSize: '16px',
                        padding: '5px',
                        lineHeight: 1.5,
                        backgroundColor: 'white',
                        border: '2px solid #f5f5f5',
                        borderRadius: '5px'
                      }}
                      onChange={(e) =>
                        this.handleInputAnswerValue(e.target.value)
                      }
                    />
                    <button
                      style={{
                        width: '30%',
                        marginBottom: '10px',
                        marginTop: '15px',
                        color: 'white',
                        backgroundColor: '#2466AF',
                        border: 'none',
                        borderRadius: '8px'
                      }}
                      onClick={() => this.handleBtnCheckAnswerView()}
                    >
                      Enviar
                    </button>
                  </>
                ) : (
                  <>
                    <div
                      className="col-md-12"
                      style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        color: 'black',
                        height: 'fit-content'
                      }}
                    >
                      <p
                        style={{
                          fontFamily: 'sans-serif',
                          color: 'rgba(0, 0, 0, 0.87)',
                          fontWeight: '500',
                          marginTop: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        Sua resposta
                      </p>
                      <p
                        style={{
                          fontFamily: 'sans-serif',
                          color: this.checkAnswerDiscursive(
                            correctAnswer,
                            answerValue,
                            arrayCorrectAnswer
                          ),
                          fontWeight: '400',
                          fontSize: '17px',
                          marginTop: '8px'
                        }}
                      >
                        {answerValue}
                      </p>
                      <p
                        style={{
                          fontFamily: 'sans-serif',
                          color: 'rgba(0, 0, 0, 0.87)',
                          fontWeight: '500',
                          marginTop: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        Expectativa de resposta
                      </p>
                      <p
                        style={{
                          fontFamily: 'sans-serif',
                          fontWeight: '400',
                          fontSize: '17px',
                          marginTop: '8px'
                        }}
                      >
                        {arrayCorrectAnswer
                          ? arrayCorrectAnswer.join(', ')
                          : correctAnswer}
                      </p>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                {/* Discursiva Multipla Resposta */}
                <style>
                  {`
                    .discursiva-multipla-resposta ul {
                      list-style-type: none;
                      padding: 0;
                      margin: 0;
                    }

                    .discursiva-multipla-resposta ul li:before {
                      content: '•';
                      display: inline-block;
                      width: 10px;
                      margin-right: 5px;
                    }
                    `}
                </style>

                <div
                  className="discursiva-multipla-resposta"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    borderRadius: '8px',
                    boxShadow: '0px 1px 4px rgb(58 58 58 / 50%)',
                    backgroundColor: '#fff'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '50px',
                        height: '50px',
                        borderTopRightRadius: '8px',
                        borderBottomLeftRadius: '30px',
                        boxShadow: '0px 1px 4px rgb(58 58 58 / 50%)'
                      }}
                    >
                      {resDiscursivaMultAlternative.length}/
                      {item.numero_respostas}
                    </div>
                  </div>

                  <span
                    style={{
                      fontFamily: 'sans-serif',
                      color: 'rgba(0, 0, 0, 0.87)',
                      fontWeight: '400',
                      marginTop: '4px',
                      width: '100%',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    dangerouslySetInnerHTML={{ __html: item.situacao_problema }}
                  />
                  <span
                    style={{
                      fontFamily: 'sans-serif',
                      color: 'rgba(0, 0, 0, 0.87)',
                      width: '100%',
                      fontWeight: '400',
                      marginTop: '4px',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    dangerouslySetInnerHTML={{ __html: item.comando_resposta }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '70%',
                      boxShadow: 'rgb(58 58 58 / 50%) 1px 1px 1px 1px',
                      borderRadius: '8px',
                      marginBottom: '1rem'
                    }}
                  >
                    {answerView == 1 ? (
                      <>
                        <div>
                          {resDiscursivaMultAlternative.map((item) => (
                            <div>{item}</div>
                          ))}
                        </div>
                        <textarea
                          style={{
                            fontSize: '16px',
                            padding: '5px',
                            width: '50%',
                            maxWidth: '50%',
                            backgroundColor: 'white',
                            border: '2px solid rgb(245, 245, 245)',
                            borderRadius: '5px',
                            marginTop: '15px',
                            resize: 'horizontal'
                          }}
                          value={this.answerValue}
                          onChange={(e) =>
                            this.handleInputAnswerValue(e.target.value)
                          }
                          maxLength={
                            item.max_caracteres
                              ? item.max_caracteres
                              : undefined
                          }
                          placeholder="Escreva sua resposta..."
                        />
                        <p style={{ marginLeft: '25%' }}>
                          {item.max_caracteres ? (
                            <>
                              {item.max_caracteres - answerLength} caracteres
                              restantes
                            </>
                          ) : (
                            ''
                          )}
                        </p>
                        <button
                          style={{
                            width: '30%',
                            marginBottom: '10px',
                            marginTop: '15px',
                            color: 'white',
                            backgroundColor: '#2466AF',
                            border: 'none',
                            borderRadius: '8px'
                          }}
                          onClick={() => this.handleBtnAnswerView()}
                        >
                          Enviar
                        </button>
                      </>
                    ) : (
                      <>
                        {showAnswer ? (
                          <>
                            <p
                              style={{
                                fontFamily: 'sans-serif',
                                color: 'rgba(0, 0, 0, 0.87)',
                                fontWeight: '500',
                                marginTop: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              Respostas aceitas
                            </p>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alingItems: 'center'
                              }}
                            >
                              {questions.map((res) => (
                                <>
                                  <span
                                    style={{
                                      fontFamily: 'sans-serif',
                                      fontSize: '17px',
                                      textAlign: 'center',
                                      fontWeight: '400',
                                      marginTop: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: res }}
                                  />
                                </>
                              ))}
                            </div>

                            <button
                              style={{
                                width: '30%',
                                marginBottom: '10px',
                                marginTop: '15px',
                                color: 'white',
                                backgroundColor: '#2466AF',
                                border: 'none',
                                borderRadius: '8px'
                              }}
                              onClick={() => this.handleBtnCorrectAnswer()}
                            >
                              Suas respostas
                            </button>
                          </>
                        ) : (
                          <>
                            <p
                              style={{
                                fontFamily: 'sans-serif',
                                color: 'rgba(0, 0, 0, 0.87)',
                                fontWeight: '500',
                                marginTop: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              Suas respostas
                            </p>
                            <div>
                              {resDiscursivaMultAlternative.map((item) => {
                                const res = this.checkAnswerMultipleDiscursive(
                                  item,
                                  questions
                                );
                                res.correct && questions.splice(res.index, 1);

                                return (
                                  <p
                                    style={{
                                      fontFamily: 'sans-serif',
                                      color: res.correct
                                        ? '#008000'
                                        : '#800000',
                                      fontWeight: '400',
                                      fontSize: '17px',
                                      marginTop: '8px'
                                    }}
                                  >
                                    {item}
                                  </p>
                                );
                              })}
                            </div>

                            <button
                              style={{
                                width: '30%',
                                marginBottom: '10px',
                                marginTop: '15px',
                                color: 'white',
                                backgroundColor: '#2466AF',
                                border: 'none',
                                borderRadius: '8px'
                              }}
                              onClick={() => this.handleBtnCorrectAnswer()}
                            >
                              Respostas aceitas
                            </button>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        <ModalCreateComentario
          isModalOpen={showCommentModal}
          avaliacaoItem={avaliacaoItem}
          api={this.props.api}
          handleModal={this.handleModal}
          selectedSpan={this.state.selectedSpan}
        />
      </div>
    );
  }

  renderDiscursivoRubricas() {
    const { item } = this.props;
    const { rubricas } = this.state;

    return (
      <div id={`item-${get(item, 'id')}`}>
        <div>
          <div className="row">
            <LabelView
              html
              name="situacao_problema"
              title="Enunciado"
              text={(() => {
                const original = get(item, 'situacao_problema', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
            />
            <LabelView
              html
              name="expectativa_resposta"
              title="Comando resposta"
              text={(() => {
                const original = get(item, 'comando_resposta', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
            />
            <LabelView
              html
              name="expectativa_resposta"
              title="Expectativa de resposta"
              text={(() => {
                const original = get(item, 'expectativa_resposta', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
            />
            <LabelView
              html
              name="orientacao_correcao"
              title="Orientação de correção"
              text={(() => {
                const original = get(item, 'orientacao_correcao', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
            />
          </div>
          <div className="row">
            <LabelView
              html
              col="col-md-3"
              title="Mínimo de palavras"
              text={(() => {
                const original = get(item, 'min_palavras', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
              name="min_palavras"
            />
            <LabelView
              html
              col="col-md-3"
              title="Máximo de palavras"
              text={(() => {
                const original = get(item, 'max_palavras', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
              name="max_palavras"
            />
            <LabelView
              html
              col="col-md-3"
              title="Mínimo de linhas"
              text={(() => {
                const original = get(item, 'min_linhas', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
              name="min_linhas"
            />
            <LabelView
              html
              col="col-md-3"
              title="Máximo de linhas"
              text={(() => {
                const original = get(item, 'max_linhas', '-');
                const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
                return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
              })()}
              name="max_linhas"
            />
          </div>
          <dt style={{ color: '#453166' }}>Rubricas</dt>
          {rubricas.map((rubrica) => (
            <div className="row mt-3">
              <div className="col-md-6">
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span
                    style={{
                      fontFamily: 'Quicksand',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#737373'
                    }}
                  >
                    Descrição:
                  </span>
                  <input
                    value={get(rubrica, 'descricao')}
                    style={{
                      width: '100%',
                      padding: '0.2rem'
                    }}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span
                    style={{
                      fontFamily: 'Quicksand',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#737373'
                    }}
                  >
                    Valor:
                  </span>
                  <input
                    value={get(rubrica, 'valor')}
                    style={{
                      width: '100%',
                      padding: '0.2rem'
                    }}
                    disabled
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderPlurall() {
    const { item } = this.props;

    return (
      <div id={`item-${get(item, 'id')}`}>
        <div className="row">
          <LabelView
            html
            name="situacao_problema"
            title="Enunciado"
            text={(() => {
              const original = get(item, 'situacao_problema', '-');
              const comentarios = get(this.props, 'avaliacaoItem.comentarios') || get(item, 'comentarios');
              return typeof original === 'string' ? this.getHighlightedHtml(original, comentarios) : original;
            })()}
          />
        </div>
      </div>
    );
  }
  renderFlashCard() {
    const { item } = this.props;
    return <FlashCard item={item} />;
  }

  render() {
    const { item } = this.props;
    const tipo = get(item, 'tipo.id');

    switch (tipo) {
      case TIPOS_ITENS.DISCURSIVO:
        return this.renderDiscursivo();
      case TIPOS_ITENS.DISCURSIVO_COM_RUBICAS:
        return this.renderDiscursivoRubricas();
      case TIPOS_ITENS.ESCALA_LINEAR_MULTIPLA:
        return this.renderEscalaLinearMultipla();
      case TIPOS_ITENS.FLASH_CARD:
        return this.renderFlashCard();
      case TIPOS_ITENS.LACUNA:
        return <Lacuna item={item} />;
      case TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA:
        return this.renderDiscursivo();
      case TIPOS_ITENS.IMAGEM:
        return this.renderimagem();

      default:
        return this.renderConteudo();
    }
  }
}

export default ItemConteudo;
